import { useQuery } from "@tanstack/react-query";
import Tabs from "../../../elements/Tabs";
import AdvanceSettings from "./AdvanceSettings";
import Advertisement from "./Advertisement";
import UserPrivilege from "./UserPrivilege";
import UserProfile from "./UserProfile";
import { userDetails } from "../../../../services/userService";
import { initialsValue, capitalizeFirst } from "../../../../helpers";
import Indentification from "../../../elements/Indentification";
import Subscription from "../../../../pages/admin/modules/Subscription";
import Transaction from "../../../../pages/admin/modules/Transaction";
import Activity from "../../../../pages/admin/modules/Activity";
import List from "./List";
import FollowList from "./FollowList";
import Achievements from "./Achievements";

const ManageUser = ({ roleCode = "user", getResponse = () => {}, close = () => {}, data, selectedTab, setSelectedTab = () => {} }) => {
  const {
    data: details,
    isLoading: detailsLoading,
    isFetching: detailsFetching,
  } = useQuery({
    queryKey: ["user-details", data?._id],
    queryFn: async () => {
      const res = await userDetails({ id: `user-${data?.uid}` });
      return res?.data;
    },
    enabled: !!data?._id,
  });

  const tabs = [
    {
      label: `Profile`,
      icon: "fa-light fa-user",
      content: <UserProfile roleCode={roleCode} details={details} getResponse={getResponse} loading={detailsLoading || detailsFetching} />,
    },
    // ...(data?._id
    //   ? [
    //       {
    //         label: "Advance Settings",
    //         icon: "fa-light fa-gear",
    //         type: "image",
    //         content: <AdvanceSettings details={details} getResponse={getResponse} loading={detailsLoading || detailsFetching} />,
    //       },
    //       ...(roleCode === "user"
    //         ? [
    //             {
    //               label: "Favourites",
    //               icon: "fa-solid fa-user-check",
    //               type: "image",
    //               content: (
    //                 <>
    //                   <h3 className="text-[30px] font-bold text-primary mb-8">Followers</h3>
    //                   <FollowList userRole="artist" isFollow="true" userId={details?._id}/>
    //                 </>
    //               ),
    //             },
    //             {
    //               label: "Achievements",
    //               icon: "fas fa-medal",
    //               type: "image",
    //               content: (<><Achievements userId={details?._id}/></>)
    //             },
    //           ]
    //         : []),
    //       // {
    //       //   label: "Subscription",
    //       //   icon: "fa-solid fa-money-check-dollar",
    //       //   type: "image",
    //       //   content: <Subscription />,
    //       // },
    //       {
    //         label: "Transaction",
    //         icon: "fa-light fa-hand-holding-dollar",
    //         type: "image",
    //         content: <Transaction userId={details?._id}/>,
    //       },
    //       {
    //         label: "Activity logs",
    //         icon: "fa-solid fa-list-timeline",
    //         type: "image",
    //         content: <Activity userId={details?._id} />,
    //       },
    //     ]
    //   : []),
  ];

  const name = data?.firstName + " " + data?.lastName;

  return (
    <div className="px-6 mt-4 h-full">
      {data?._id && (
        <div className="flex items-center font-medium text-xl text-slate-600">
          <span className="text-[18px] text-slate-400">{`${capitalizeFirst(roleCode)}s`}/</span>
          <div className="relative flex items-center ml-2">
            <Indentification initial={initialsValue(name)} image={data?.image?.url} alt={name} fill={true} className="" size="md" />
            <div className="text-md mx-2">{name}</div>
          </div>
        </div>
      )}

      <div className="mt-4 relative">
        <Tabs items={tabs} selectedIndex={selectedTab} setSelectedIndex={setSelectedTab} />
      </div>
    </div>
  );
};

export default ManageUser;
